import React, { Component } from 'react';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAws, faCss3, faHtml5, faJs, faNodeJs, faPython } from '@fortawesome/free-brands-svg-icons';

import './IconSet.css';

class IconSet extends Component {

    render() {
        return (
            <section id={this.props.id} className='text-center vertical-center'>

                <Container fluid>
                    <Row>
                        <Col md className='icon col-6 col-sm-4'>
                            <FontAwesomeIcon icon={ faJs } size='4x' />
                        </Col>
                        <Col md className='icon col-6 col-sm-4'>
                            <FontAwesomeIcon icon={ faPython } size='4x' />
                        </Col>
                        <Col md className='icon col-6 col-sm-4'>
                            <FontAwesomeIcon icon={ faNodeJs } size='4x' />
                        </Col>
                        <Col md className='icon col-6 col-sm-4'>
                            <FontAwesomeIcon icon={ faAws } size='4x' />
                        </Col>
                        <Col md className='icon col-6 col-sm-4'>
                            <FontAwesomeIcon icon={ faCss3 } size='4x' />
                        </Col>
                        <Col md className='icon col-6 col-sm-4'>
                            <FontAwesomeIcon icon={ faHtml5 } size='4x' />
                        </Col>
                    </Row>
                </Container>

            </section>
        );
    }

}

export default IconSet;

/* faAndroid faAngular faApple faAtlassian faBitbucket
faConfluence faCss3-alt faGit faGithub faJenkins faJira
faJs-square faNode faNpm faReact faSass faVuejs faCode
*/